const EPS = 1e-6;

export default class Event {
  constructor(config) {
    this.time = config.time;
    this.juggler = config.juggler;
    this.hand = config.hand;
    this.duration = config.duration;
    this.toJuggler = config.toJuggler;
    this.toHand = config.toHand;
    this.toEvent = undefined;
    this.incoming = 0;
  }

  getLabel(numJugglers) {
    if (this.hasThrow()) {
      let x = "";
      if (this.juggler == this.toJuggler) {
        if ((this.duration % 2 == 1) ^ (this.hand != this.toHand)) {
          x = "x";
        }
      } else {
        if (this.hand == this.toHand) {
          x = "x";
        }
      }
      const isInt = Math.abs(this.duration - Math.round(this.duration)) < EPS;
      const duration = this.duration.toFixed(isInt ? 0 : 1);
      if (this.juggler == this.toJuggler) {
        return duration + x;
      } else if (numJugglers == 2) {
        return duration + "p" + x;
      } else {
        return duration + "p" + x + this.toJuggler;
      }
    } else {
      return "";
    }
  }

  toJIFThrow(limbs) {
    return {
      time: this.time,
      duration: this.duration,
      from: limbs.findIndex(limb => limb.juggler == this.juggler && limb.type == (this.hand ? "right hand" : "left hand")),
      to: limbs.findIndex(limb => limb.juggler == this.toJuggler && limb.type == (this.toHand ? "right hand" : "left hand")),
      label: this.getLabel(limbs.length / 2), // Assuming 2 limbs per juggler
    };
  }

  addThrow(toEvent, numBeats) {
    this.duration = toEvent.time - this.time + 2;
    if (this.duration < 0) {
      this.duration += numBeats;
    }
    this.toJuggler = toEvent.juggler;
    this.toHand = toEvent.hand;
    this.toEvent = toEvent;
  }

  removeThrow() {
    this.duration = undefined;
    this.toJuggler = undefined;
    this.toHand = undefined;
    this.toEvent = undefined;
  }

  hasThrow() {
    return this.duration !== undefined;
  }

  isValid() {
    if (this.duration < 0) {
      return false;
    } else if (this.duration == 0 && (this.juggler != this.toJuggler || this.hand != this.toHand)) {
      return false;
    }
    return (this.incoming == (this.hasThrow() ? 1 : 0));
  }

  cmp(other) {
    return this.time - other.time || this.juggler - other.juggler || this.hand - other.hand;
  }

  id() {
    return this.juggler + " " + this.hand + " " + this.time;
  }
}
